import React, { useEffect, useState } from "react";
import api from "../../services/api";
import KoraxProspection from "../../pages/KoraxProspection";

// Nao exibir links nem montar a pagina ate a API autorizar esta sessao.
const useMasterAccess = () => {
  const [allowed, setAllowed] = useState(null);
  useEffect(() => {
    let mounted = true;
    api.get("/korax-prospection/access")
      .then(({data}) => { if (mounted) setAllowed(data?.allowed === true); })
      .catch(() => { if (mounted) setAllowed(false); });
    return () => { mounted = false; };
  }, []);
  return allowed;
};

export const ProspectionMasterMenuGate = ({ children }) => {
  const allowed = useMasterAccess();
  return allowed === true ? <>{children}</> : null;
};

export const MasterProspectionPage = props => {
  const allowed = useMasterAccess();
  if (allowed === null) return <div style={{padding: 24, color: "#64748B"}}>Verificando acesso à Prospecção...</div>;
  if (allowed !== true) return <div style={{padding: 24, maxWidth: 650}}>
    <h2 style={{color: "#010B36", fontSize: 22}}>Acesso restrito</h2>
    <p>Prospecção Inteligente disponível somente para o administrador master autorizado.</p>
  </div>;
  return <KoraxProspection {...props} />;
};
